import React from 'react';
import { Link, useParams } from 'react-router-dom';
import { PageTitle, Button } from '@cordata/buffet';

import Admissions from '~/components/Admission/Card';

const AdmissionsCollection = () => {
  const params = useParams();

  return (
  <>
    <PageTitle
      action={
        <Button
          outline
          tag={Link}
          to={`/patients/${params.patient_id}/admissions/add`}
          icon="plus"
        >
         Add Admission
        </Button>
      }
    >
      Admissions
    </PageTitle>

    <Admissions params={params} header={false} />
  </>
  );
};

export default AdmissionsCollection;
